import { DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManualOfficePostingReport extends Layout {
    excludabletextboxPayee: ExcludableTextbox;
    sourceManualOfficePosting: DataSource;
    textboxCutoffDate: Textbox;
}
